<template>
    <div class="modal-conciliação">
        <v-dialog @input="close" v-model="open" width="1200">
            <v-card>
                <v-card-title class="d-flex justify-space-between">
                    <p class="title">Conciliar Boleto</p>
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="6" sm="12">
                            <v-text-field
                                hide-details
                                dense
                                label="Código de barras"
                                v-model="boleto.codigo_de_barras"
                                outlined
                                disabled
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" sm="12">
                            <v-text-field
                                hide-details
                                dense
                                label="Valor do Boleto"
                                v-model="valorBoletoComputed"
                                outlined
                                disabled
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" sm="12">
                            <v-text-field
                                hide-details
                                dense
                                label="Data Vencimento"
                                v-model="dataVencimentoComputed"
                                outlined
                                disabled
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" sm="12">
                            <v-text-field
                                hide-details
                                dense
                                label="Valor Pago"
                                v-model="valorPagoComputed"
                                outlined
                                disabled
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" sm="12">
                            <v-text-field
                                hide-details
                                dense
                                label="Data Pagamento"
                                v-model="dataPagamentoComputed"
                                outlined
                                disabled
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-col>
                    <v-divider></v-divider>
                </v-col>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="6" sm="12">
                            <v-text-field
                                dense
                                outlined
                                append-icon="search"
                                v-model="numeroAuto"
                                label="Digite o número do Auto"
                                @keyup.enter="getAuto(numeroAuto)"
                                @click:append="getAuto(numeroAuto)"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" sm="12">
                            <v-text-field
                                hide-details
                                dense
                                label="Placa"
                                v-model="placa"
                                outlined
                                disabled
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" sm="12">
                            <v-text-field
                                hide-details
                                dense
                                label="Data Infração"
                                v-model="dataInfracao"
                                outlined
                                disabled
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" sm="12">
                            <v-text-field
                                hide-details
                                dense
                                label="Número de Autenticação do Pagamento"
                                v-model="numeroAutenticacaoPagamento"
                                outlined
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" outlined @click="cancelar"
                        >cancelar</v-btn
                    >
                    <v-btn color="primary" @click="salvar">salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { showError } from "@/global";
import Modal from "@/components/Modal/Modal";
import urlApi from "@/routes/urlApi";

export default {
    name: "ConciliarBoletoModal",
    components: { Modal },
    props: {
        boleto: {
            type: Object,
            require: true,
        },
    },
    data() {
        return {
            idAuto: null,
            dataInfracao: null,
            placa: null,
            numeroAuto: null,
            numeroAutenticacaoPagamento: null,
            open: true,
        };
    },
    computed: {
        valorBoletoComputed() {
            return this.boleto.valor_boleto
                ? this.$options.filters.dinheiro(this.boleto.valor_boleto)
                : "";
        },
        valorPagoComputed() {
            return this.boleto.valor_pago
                ? this.$options.filters.dinheiro(this.boleto.valor_pago)
                : "";
        },
        dataPagamentoComputed() {
            return this.$options.filters.data(this.boleto.data_pagamento);
        },
        dataVencimentoComputed() {
            return this.$options.filters.data(this.boleto.data_vencimento);
        },
    },
    methods: {
        async getAuto(numeroAuto) {
            try {
                const response = await this.$http.get(
                    `${urlApi}/auto/${numeroAuto}`
                );
                const data = { ...response.body.data };
                this.placa = data.veiculo_placa;
                this.dataInfracao = data.data_infracao;
                this.idAuto = data.id_auto;
            } catch (error) {
                console.log(error);
                showError("Auto não encontrado");
            }
        },
        async salvar() {
            if (!this.idAuto) {
                showError("Auto é obrigatório");
                return;
            }
            if (!this.numeroAutenticacaoPagamento) {
                showError("O número de autenticação é obrigatório");
            }

            const payload = {
                auto_id: this.idAuto,
                numero_autenticacao_pagamento: this.numeroAutenticacaoPagamento,
            };
            try {
                const data = await this.$http.put(
                    `${urlApi}/boletos/${this.boleto.id}/conciliar`,
                    payload
                );
                this.$toasted.global.defaultSuccess();
                this.close()
            } catch (error) {
                showError(error);
            }
        },
        cancelar() {},
        close() {
            this.$emit("close");
        },
    },
};
</script>
